exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".webamp-desktop {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: -1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /node_modules/css-loader!./css/milkdrop-window.css
// module id = 190
// module chunks = 5